import { render, staticRenderFns } from "./shenheYuceXhjl.vue?vue&type=template&id=1b528f46&scoped=true"
import script from "./shenheYuceXhjl.vue?vue&type=script&lang=js"
export * from "./shenheYuceXhjl.vue?vue&type=script&lang=js"
import style0 from "./shenheYuceXhjl.vue?vue&type=style&index=0&id=1b528f46&prod&scoped=true&lang=css"
import style1 from "./shenheYuceXhjl.vue?vue&type=style&index=1&id=1b528f46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b528f46",
  null
  
)

export default component.exports